import axios from "axios";
import { IResponse } from "features/common/hooks/useRequest";
import { ValidationResult } from "features/common/models/ValidationResult";

export async function deleteAnaliseCritica(id: string): Promise<IResponse<ValidationResult>> {
    return await axios.delete(`/AnaliseCritica/${id}`);
}
